"use client"
import { create } from "zustand"

interface LinkedWalletModalStore {
  isLinkedWalletModalOpen: boolean
  isAddingNewWallet: boolean

  setIsLinkedWalletModalOpen: (open: boolean) => void
  setIsAddingNewWallet: (adding: boolean) => void
  openAddWalletModal: () => void
}

export const useLinkedWalletModalStore = create<LinkedWalletModalStore>(
  set => ({
    isLinkedWalletModalOpen: false,
    isAddingNewWallet: false,
    setIsLinkedWalletModalOpen: isLinkedWalletModalOpen =>
      set({ isLinkedWalletModalOpen }),
    setIsAddingNewWallet: isAddingNewWallet => set({ isAddingNewWallet }),
    openAddWalletModal: () =>
      set({ isLinkedWalletModalOpen: true, isAddingNewWallet: true }),
  }),
)
